const contactItems = [
  {
    icon: "ri-map-pin-line",
    label: "Address",
    value: "BRANISLAVA NUSICA 2",
  },
  {
    icon: "ri-building-line",
    label: "City",
    value: "Valjevo",
  },
  {
    icon: "ri-mail-send-line",
    label: "Zip Code",
    value: "250906",
  },
  {
    icon: "ri-global-line",
    label: "Country",
    value: "Serbia",
  },
  {
    icon: "ri-mail-line",
    label: "Email",
    value: "help@komasdoo.com",
  },
  {
    icon: "ri-phone-line",
    label: "Number",
    value: "+1 3204313764",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="w-full bg-[#080808] py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-20">
          <p className="text-[#C9A85C] text-xs tracking-[5px] uppercase font-medium mb-4">
            Get in Touch
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            Contact Information
          </h2>
          <p className="text-white/40 text-lg">We&apos;re here to help you.</p>
          <div className="mt-8 mx-auto w-16 h-px bg-gradient-to-r from-transparent via-[#C9A85C] to-transparent" />
        </div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {contactItems.map((item) => (
            <div
              key={item.label}
              className="group bg-white/[0.03] border border-white/[0.06] rounded-2xl p-7 hover:bg-white/[0.05] hover:border-[#C9A85C]/15 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-xl bg-[#C9A85C]/10 border border-[#C9A85C]/20">
                  <i className={`${item.icon} text-[#C9A85C] text-lg`} />
                </div>
                <div>
                  <p className="text-white/40 text-xs uppercase tracking-widest mb-1.5 font-medium">
                    {item.label}
                  </p>
                  <p className="text-white text-base font-medium leading-snug">
                    {item.value}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="mt-24 border-t border-white/[0.06]" />

        {/* Footer */}
        <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/5eb830a6-33cd-4e9c-8054-fbfb688c5e2a.png"
              alt="KOMAS DOO"
              className="h-7 w-auto object-contain opacity-60"
            />
            <span className="text-white/40 text-sm tracking-wider">KOMAS DOO</span>
          </div>
          <p className="text-white/30 text-sm tracking-wide">
            &copy; {new Date().getFullYear()} KOMAS DOO. All rights reserved.
          </p>
          <p className="text-white/20 text-xs tracking-wider uppercase">
            iOS App Development &middot; Serbia
          </p>
        </div>
      </div>
    </section>
  );
}
